import { render, staticRenderFns } from "./DirectDebitOptIn.vue?vue&type=template&id=2ead7949&scoped=true&"
import script from "./DirectDebitOptIn.vue?vue&type=script&lang=js&"
export * from "./DirectDebitOptIn.vue?vue&type=script&lang=js&"
import style0 from "./DirectDebitOptIn.vue?vue&type=style&index=0&id=2ead7949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ead7949",
  null
  
)

export default component.exports